<template>
  <div class="person-list main-content-cj h-100 mh-100">
    <b-container class="d-flex flex-column h-100 mh-100">
      <div class="main-header">
        <b-row class="align-items-center">
          <b-col cols="12" md="6" class="d-flex align-content-center">
            <span class="title">Lista de {{ termPlural }}</span>
          </b-col>
        </b-row>
        <hr class="mb-0">
      </div>
      <div class="box-container" v-if="module == 'patients'">
        <b-row>
          <b-col cols="12">
            <div class="box-cj">
              <div class="header">
                <div class="d-flex justify-content-between">
                  <p class="title">Pacientes em atendimento</p>
                </div>
              </div>
              <div class="content">
                <table class="table table-responsive w-100 d-block d-md-table main-table-cj">
                  <thead>
                    <tr>
                      <th>Nome</th>
                      <th>Profissonal</th>
                      <th>Início do atendimento</th>
                      <th>Formato</th>
                      <th v-if="user.person.type == 'PROFESSIONAL'"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <router-link tag="tr" :to="'/'+url+'/'+person.id" v-for="person in patientsInAttendance" :key="person.id">
                      <td>{{ person.name }} {{ (person.internal_code != null && person.internal_code != '')?'('+person.internal_code+')':''}} {{ (helpers.getOwnerId() == person.id)?'(Gestor)':'' }}</td>
                      <td>{{ person.professional }}</td>
                      <td>{{ moment(person.attendance_created_at).format('DD/MM/YYYY HH:mm') }}</td>
                      <td>{{ person.appointment_format ? person.appointment_format : 'Presencial' }}</td>
                      <td v-if="user.person.type == 'PROFESSIONAL'" class="text-right">
                        <router-link v-if="person.telehealth_id == null" tag="button" class="btn btn-sm btn-primary" :to="'/pacientes/' + person.id"><i class="fas fa-sm fa-external-link-alt mr-2 "></i> Acessar atendimento</router-link>
                        <router-link v-else-if="person.professional_id == user.person.id" tag="button" class="btn btn-sm btn-primary" :to="'/pacientes/' + person.id + '/teleconsulta/' + person.telehealth_id"><i class="fas fa-sm fa-external-link-alt mr-2 "></i> Acessar atendimento</router-link>
                        <router-link v-else tag="button" class="btn btn-sm btn-primary" :to="'/pacientes/' + person.id + '/acompanhar-teleconsulta/' + person.appointment_id"><i class="fas fa-sm fa-external-link-alt mr-2 "></i> Acessar atendimento</router-link>
                      </td>
                    </router-link>
                  </tbody>
                </table>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>

      <div class="box-container">
        <b-row>
          <b-col cols="12">
            <div class="box-cj">
              <div class="header">
                <b-row class="d-flex align-items-center">
                  <b-col cols="12" xl="6" class="mb-2 mb-xl-0">
                    <b-row class="d-flex align-items-center">
                      <b-col cols="auto">
                        <p class="title"><small>{{ pagination.total }} {{ termPlural }} cadastrados</small></p>
                      </b-col>
                      <b-col cols="auto">
                        <b-form-input type="text" :placeholder="'Buscar por '+termSingular" v-model="searchBy"></b-form-input>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="12" xl="6" class="text-right">
                    <router-link v-if="canAdd" tag="a" class="btn btn-primary btn-sm mr-2" :to="'/'+url+'/'+newTerm"><i class="far fa-dot-circle"></i> Cadastrar {{ termSingular }}</router-link>
                    <b-button size="sm" v-if="module == 'patients'" variant="primary" @click="exportPeople()"><i class="far fa-download"></i> Exportar {{ termPlural }}</b-button>
                  </b-col>
                </b-row>
              </div>
              <div class="content">
                <table class="table table-responsive w-100 d-block d-md-table main-table-cj">
                  <thead>
                    <tr>
                      <th>Nome</th>
                      <th>E-mail</th>
                      <th>Data de Nascimento</th>
                      <th>Telefone</th>
                      <th v-if="module == 'patients'"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="line-add" v-if="canAdd">
                      <td :colspan="module == 'patients' ? 5 : 4" class="text-center">
                        <router-link tag="a" class="btn btn-block btn-sm btn-add-new" :to="'/'+url+'/'+newTerm"><i class="far fa-plus-circle"></i> Adicionar nov{{ letter}} {{termSingular}}</router-link>
                      </td>
                    </tr>
                    <router-link tag="tr" :to="'/'+url+'/'+person.id" v-for="person in people" :key="person.id">
                      <td>
                        <i v-if="module == 'professionals'" class="fa fa-circle mr-1 professional-indicator" :style="'color:' + person.indicator_color"></i>
                        {{ person.name }} {{ (person.internal_code != null && person.internal_code != '')?'('+person.internal_code+')':''}} {{ (helpers.getOwnerId() == person.id)?'(Gestor)':'' }}
                      </td>
                      <td>{{ person.email }}</td>
                      <td>{{ (person.birthday != null)?moment(person.birthday).format('DD/MM/YYYY'):'' }}</td>
                      <td>{{ (person.cellphone != '')?person.cellphone:person.telephone }}</td>
                      <td v-if="module == 'patients'">
                        <router-link tag="button" class="btn btn-primary btn-sm mr-2" title="Ficha Paciente" :to="'/'+url+'/'+person.id"><i class="far fa-address-card"></i></router-link>
                        <router-link tag="button" class="btn btn-primary btn-sm" title="Editar cadastro" v-if="canEdit" :to="'/'+url+'/'+person.id+'?editar=1'"><i class="far fa-user-edit"></i></router-link>
                      </td>
                    </router-link>
                  </tbody>
                </table>
                <p v-if="searchBy == '' && people.length == 0" class="text-center sub-title">Você ainda não possui nenhum{{ (letter != 'o')?letter:'' }} {{ termSingular }} cadastrad{{ letter }}.</p>
                <p v-if="searchBy != '' && people.length == 0" class="text-center sub-title">A sua busca por {{ termSingular }} com o termo "{{ searchBy }}" não encontrou nenhum resultado.</p>

                <div v-if="pagination.lastPage > 1">
                  <hr>
                  <b-pagination v-model="pagination.currentPage" :total-rows="pagination.lastPage * pagination.perPage" :per-page="pagination.perPage" limit="15" align="fill" first-number last-number @change="getPeople"></b-pagination>
                </div>

              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        leavingPage: false,
        user: null,

        termSingular: '',
        termPlural: '',
        url: '',
        letter: '',
        newTerm: '',
        module: '',

        pagination: {
          currentPage: 1,
          lastPage: 1,
          perPage: 20,
          total: 0
        },

        canSee: true,
        canAdd: true,
        canEdit: true,
        canRemove: true,

        patientsInAttendance: [],

        people: [],
        peopleFiltred: [],

        searchBy: '',
        searchByTimer: null
      }
    },
    mounted () {
      this.user = JSON.parse(localStorage.getItem('user'));

      if(this.$route.meta.type == 'PROFESSIONAL') {
        this.termSingular = 'profissional';
        this.termPlural = 'profissionais';
        this.url = 'profissionais';
        this.letter = 'o';
        this.newTerm = 'cadastrar-profissional';
        this.module = 'professionals';
      } else if(this.$route.meta.type == 'SECRETARY') {
        this.termSingular = 'secretária';
        this.termPlural = 'secretárias';
        this.url = 'secretarias';
        this.letter = 'a';
        this.newTerm = 'cadastrar-secretaria';
        this.module = 'secretaries';
      } else if(this.$route.meta.type == 'COORDINATOR') {
        this.termSingular = 'coordenador';
        this.termPlural = 'coordenadores';
        this.url = 'coordenadores';
        this.letter = 'o';
        this.newTerm = 'cadastrar-coordenador';
        this.module = 'coordinators';
      } else {
        this.termSingular = 'paciente';
        this.termPlural = 'pacientes';
        this.url = 'pacientes';
        this.letter = 'o';
        this.newTerm = 'cadastrar-paciente';
        this.module = 'patients';
      }

      this.canSee = (this.helpers.isOwner())?true:this.helpers.checkPermission(this.module, 'can_see');
      this.canAdd = (this.helpers.isOwner())?true:this.helpers.checkPermission(this.module, 'can_add');
      this.canEdit = (this.helpers.isOwner())?true:this.helpers.checkPermission(this.module, 'can_edit');
      this.canRemove = (this.helpers.isOwner())?true:this.helpers.checkPermission(this.module, 'can_remove');

      if(this.canSee == false) {
        this.$swal('Desculpe', 'Você não tem permissão para acessar este módulo!', 'error');
        this.$router.push({ path: '/' }).catch(() => {});
        return;
      }

      this.eventBus.$emit('IS_LOADING', true);
      this.getPeople(this.pagination.currentPage);
      if(this.module == 'patients') {
        this.getPatientsInAttendance();
      }
    },
    watch: {
      searchBy: function() {
        clearInterval(this.searchByTimer);  //clear any interval on key up
        const scope = this;
        this.searchByTimer = setTimeout(function() { //then give it a second to see if the user is finished
          scope.getPeople(1);
        }, 250);
      }
    },
    methods: {
      getPeople(page) {
        this.api.getPeople({type: this.$route.meta.type, name: this.searchBy, page: page}).then(res => {
          this.eventBus.$emit('IS_LOADING', false);
          if(this.leavingPage) {
            return;
          }
          this.people = res.data.data;

          this.pagination.currentPage = res.data.current_page;
          this.pagination.lastPage = res.data.last_page;
          this.pagination.total = res.data.total;

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response People', res);
        }).catch(err => {
          this.eventBus.$emit('IS_LOADING', false);
          if(this.leavingPage) {
            return;
          }
          this.$swal('Ops...', 'Não conseguimos carregar os pacientes da sua clínica! Por favor, entre em contato com o suporte!', 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error People', err.response);
        });
      },

      getPatientsInAttendance() {
        this.api.getPatientsInAttendance().then(res => {
          this.eventBus.$emit('IS_LOADING', false);
          if(this.leavingPage) {
            return;
          }
          this.patientsInAttendance = res.data;

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response AttendancesInProgress', res);
        }).catch(err => {
          this.eventBus.$emit('IS_LOADING', false);
          if(this.leavingPage) {
            return;
          }
          this.$swal('Ops...', 'Não conseguimos carregar os pacientes em atendimento da sua clínica! Por favor, entre em contato com o suporte!', 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error AttendancesInProgress', err.response);
        });
      },

      exportPeople() {
        this.eventBus.$emit('IS_LOADING', true);
        this.api.exportPeople({type: this.$route.meta.type, name: this.searchBy, export: true}).then(res => {
          this.eventBus.$emit('IS_LOADING', false);
          if(this.leavingPage) {
            return;
          }

          var type = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            blob = new Blob([res.data], { type: type }),
            anchor = document.createElement('a');

          anchor.download = 'pacientes.xlsx';
          anchor.href = (window.webkitURL || window.URL).createObjectURL(blob);
          anchor.dataset.downloadurl = [type, anchor.download, anchor.href].join(':');
          anchor.click();

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Export People', res);
        }).catch(err => {
          this.eventBus.$emit('IS_LOADING', false);
          if(this.leavingPage) {
            return;
          }
          this.$swal('Ops...', 'Não conseguimos exportar os pacientes da sua clínica! Por favor, entre em contato com o suporte!', 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Export People', err.response);
        });
      }
    },
    beforeRouteLeave (to, from, next) {
      this.leavingPage = true;
      next();
    }
  }
</script>

<style lang="scss">
  .person-list {
    padding: 20px 0;

    .box-cj {
      .content {
        th {
          color: $cadetGray;
          border-top: 0;
        }

        tbody {
          color: $waikawaGray;

          .line-add {
            padding: 10px 0;
          }

          tr:nth-child(even) {
            background-color: $whisper;
          }

          tr:nth-child(odd) {
          }

          .professional-indicator {
            font-size: 12px;
          }
        }
      }
    }
  }
</style>
